export default "__VITE_ASSET__BtBej5Wh__"